<template lang="pug">
  .modal.doNotDesactiveOnClick(ref="modal")
    .modal-dialog.modal-lg(v-if='open')
      .modal-content
        .modal-header
          button.close(type="button", @click='closeModal') &#215;
          h4.modal-title
            template(v-if="isEditing") {{$t("events.createModal.editing.title")}}
            template(v-else) {{$t("events.createModal.title")}}
        .modal-body
          form.form-horizontal(role="form", v-show='savingState == null')
            .form-group
              label.col-sm-2(for="inputDates") {{$t('events.createModal.fields.dates.label')}}
              .col-sm-5
                input#inputDates.form-control(v-model='dates', :placeholder="$t('events.createModal.fields.dates.placeholder')", ref='inputDates', style='display: none')
                flat-pickr(v-model="datePickerStart", :config="datePickerOptions", placeholder="Date de début", ref="datePickerStart")
                i.fa.fa-arrow-right.hidden-xs(style="position: absolute; right: -7px; top: 50%; margin-top: -5px")
                div.text-center.visible-xs
                  i.fa.fa-arrow-down
              .col-sm-5
                flat-pickr(v-model="datePickerEnd", :config="datePickerOptions", placeholder="Date de fin")
            .form-group
              label.col-sm-2(for="inputName") {{$t('events.createModal.fields.name.label')}} *
              .col-sm-10
                input#inputName.form-control(v-model='name', ref="inputName", type="text", :placeholder="$t('events.createModal.fields.name.placeholder')", debounce='100', @keyup.enter='useNameHelpIfCtrlEnter($event)')
            .form-group(v-if='nameHelp')
              .col-sm-offset-2.col-sm-10
                label
                  a.clickable(@click='useNameHelp()') 
                    i.fa.fa-arrow-circle-up
                    |  {{$t('events.createModal.fields.name.help')}} {{nameHelp.start}} - {{nameHelp.end}} 
                    small (Ctrl-Enter)
            .form-group
              label.col-sm-2(for="inputGroup") {{$t('events.createModal.fields.group.label')}} *
              .col-sm-10
                vue-select-a-group(:selectedGroup.sync="selectedGroup", :disabled="isEditing", @click="clickOnSelectAGroup")
                //- template(v-if='groopsAreLoaded')
                //-   select#inputGroup.form-control(type="text", v-model='selectedGroup', :disabled="isEditing")
                //-     option(value='-3') {{$t('events.createModal.fields.group.placeholder')}}
                //-     template(v-for='(groups, type) in groupsPerType')
                //-       option(disabled='disabled', v-if="type != 'undefined'") {{$t('groups.types.' + type)}}
                //-       option(v-for='(group, key) in groups', :value='group')
                //-         template(v-if="group.type") &nbsp;&nbsp;&nbsp;
                //-         | {{group.name}}
                    //- option(value='-1') Choisir des invités...
            .form-group(v-if='isEditing && hasClickedOnSelectAGroup')
              .col-sm-offset-2.col-sm-10
                label
                  i.fa.fa-arrow-up
                  |  
                  small {{$t('events.createModal.wantToChangeGroup')}}
                    a.clickable(@click="copyEvent") {{$t('events.createModal.copyIt')}}
            .form-group(v-if='selectedGroup')
              label.col-sm-2(for="eventTypes") {{$t('events.createModal.fields.type.label')}}*
              .col-sm-10
                template(v-if='eventTypes')
                  select#inputEventType.form-control(type="text", v-model='eventType')
                    option(v-for='(type, key) in eventTypes', :value='key') 
                      template(v-if='type.standard') {{$t('events.types.'+type.text)}}
                      template(v-if='!type.standard') {{type.text}}
                template(v-if='!eventTypes')
                  .form-control {{$t("globals.loading")}}
                template(v-if='eventType == -1')
                  input#inputNewEventType.form-control(type="text", v-model='newEventType', :placeholder="$t('events.createModal.fields.newEventType.placeholder')", ref="newEventTypeInput")

            template(v-if='mustHaveIsComplete', v-transition='expand')
              legend {{$t('events.createModal.subtitles.moreInfo')}}
              .form-group
                label.col-sm-2(for="inputDescription") {{$t('events.createModal.fields.description.label')}}
                .col-sm-10
                  textarea#inputDescription.form-control(rows="2", v-model='description', :placeholder="$t('events.createModal.fields.description.placeholder')")
              .form-group
                label.col-sm-2(for="inputAddress") {{$t('events.createModal.fields.address.label')}}
                .col-sm-10
                  input#inputAddress.form-control(type="text", v-model="address", :placeholder="$t('events.createModal.fields.address.placeholder')")
              .form-group
                label.col-sm-2(for="inputUrl") {{$t('events.createModal.fields.url.label')}}
                .col-sm-10
                  input#inputUrl.form-control(type="url", v-model='url', :placeholder="$t('events.createModal.fields.url.placeholder')")
              .form-group
                .checkbox
                  .col-sm-10.col-sm-offset-2
                    label
                      input#acceptMaybe(type="checkbox", v-model='maybe') 
                      | {{$t('events.createModal.fields.acceptMaybe.label')}}
              .form-group
                .checkbox
                  .col-sm-10.col-sm-offset-2
                    label
                      input#sendMail(type="checkbox", v-model='sendMail') 
                      | {{$t('events.createModal.fields.sendMail.label')}}
              .form-group
                .checkbox
                  .col-sm-10.col-sm-offset-2
                    label
                      input#publishOnGroupPage(type="checkbox", v-model='publishOnGroupPage') 
                      | {{$t('events.createModal.fields.publishOnGroupPage.label')}}
              .form-group
                .checkbox
                  .col-sm-10.col-sm-offset-2
                    label
                      input#blinded(type="checkbox", v-model='blinded') 
                      | {{$t('events.createModal.fields.blinded.label')}}
              .form-group(v-if="!isEditing")
                .checkbox
                  .col-sm-offset-2.col-sm-10
                    label
                      input(type="checkbox", v-model='copyToOtherDates') 
                      | {{$t('events.createModal.fields.duplicate.label')}}
                    .row(v-if="copyToOtherDates")
                      .col-sm-6
                        vue-select-dates(ref="selectDates", :selected-dates="rawCopyToDates")
                      .col-sm-6
                        p.selectDatesPlease(v-if='copyToDates.length == 0') 
                          i.fa.fa-arrow-circle-left
                          |  {{$t('events.createModal.fields.duplicate.help')}}
                        ul.selectedDatesList
                          li(v-for='date in copyToDates') {{date.format('dd, L') }}
            .row(v-if="!mustHaveIsComplete && hasClickedOnCreateBtn")
              .col-sm-2
              .col-sm-10
                .alert.alert-danger Merci d'indiquer un titre et un groupe


          .bigIconMessage(v-if='savingState == "saving"')
            i.fa.fa-refresh.fa-spin.grey
            |  {{$t("globals.sending")}}
          .bigIconMessage(v-if='savingState == "saved"')
            i.fa.fa-check.green
            |  {{$t("globals.saved")}}

          .bigIconMessage(v-if='savingState == "error"')
            i.fa.fa-remove.red
            |  {{$t("globals.error")}}
        .modal-footer(v-if='savingState == null')
          button.btn.btn-default.pull-left(type="button", @click='cancel') {{$t('globals.cancel')}}
          a.btn.clickable(@click='toggleFileMode', v-if="!isEditing") {{$t("events.createModal.toggleModeBtn")}}
          | &nbsp;
          button.btn.btn-primary(type="button", :class='{disabled: !mustHaveIsComplete}', @click='createEvent')
            template(v-if="isEditing") {{$t('globals.save')}}
            template(v-else) {{$t('globals.create')}}
</template>
<script>
import modalsBus from '@/components/shared/ModalsBus'

import $ from 'jquery'
import _ from 'lodash'
import moment from 'moment'

import autosize from 'autosize'

import Vue from 'vue'
import {mapGetters} from 'vuex'
import {unixtimeTo} from '@/components/shared/vue.globals'

import VueSelectDates from '@/components/shared/VueSelectDates'
import VueSelectAGroup from '@/components/shared/SelectAGroup'
import FlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/l10n/fr.js'
import 'flatpickr/dist/l10n/default.js'

let DEFAULT_MINUTES_GAP_BETWEEN_DATES = 60

export default {
  props: {
    eventsBus: {
      type: Object,
      required: true
    }
  },
  components: {
    VueSelectDates,
    VueSelectAGroup,
    FlatPickr
  },
  data () {
    return {
      open: false,
      description: '',
      address: '',
      url: '',
      maybe: false,
      newEventType: '',
      savingState: null,
      personalGroup: [],
      selectedGroup: null,
      startTime: null,
      endTime: null,
      name: null,
      dates: null,
      eventType: '',
      publishOnGroupPage: false,
      blinded: false,
      copyToOtherDates: false,
      sendMail: false,
      fromEvent: null,
      rawCopyToDates: {},
      datePickerStart: null,
      datePickerEnd: null,
      hasClickedOnSelectAGroup: false,
      hasClickedOnCreateBtn: false
      // onChange (selectedDates, dateStr, instance) {
      // }
    }
  },
  mounted () {
    this.initValues()
    modalsBus.onOpen((arg, datesOrEvent) => {
      if (arg === modalsBus.modals.CREATE_EVENT || arg === modalsBus.modals.COPY_EVENT) {
        if (datesOrEvent) {
          if (datesOrEvent.kind === 'event') {
            this.fromEvent = null
            this.fromEvent = datesOrEvent
            if (arg === modalsBus.modals.COPY_EVENT) {
              this.copyEvent()
            }
          } else {
            this.fromEvent = null
            this.startTime = datesOrEvent.start
            this.endTime = datesOrEvent.end
            this.initDateRange()
          }
        }
        this.openModal()
      } else {
        this.closeModal()
      }
    })
    modalsBus.onCloseAll(() => {
      this.closeModal()
    })
    this.$nextTick(() => {
      this.initDateRange()

      this.dates = $(this.$refs.inputDates).val()

      $(document).on('hidden.bs.modal', this.$refs.modal, (event) => {
        this.fromEvent = null
        this.initValues()
        this.closeModal()
      })
      $(document).on('shown.bs.modal', this.$refs.modal, () => {
        this.$nextTick(() => {
          $(this.$refs.inputName).focus()
        })
        autosize($('textarea, input', this.$refs.modal))
      })
    })
  },
  computed: {
    ...mapGetters('groops', [
      'selectedGroops',
      'firstSelectedGroop',
      'isAllGroopsSelected',
      'groopsWithOwn',
      'groopsAreLoaded',
      'firstSelectedGroopId',
      'groupsPerType',
      'hasNotMyGroopsSelected'
    ]),
    datePickerOptions () {
      return {
        dateFormat: Vue.i18n.t('globals.dateTimeFormatForPicker'),
        enableTime: true,
        locale: this.$i18n.locale,
        time_24hr: Vue.i18n.t('globals.in24h') === 'true'
      }
    },
    copyToDates () {
      var dates, key, value, _ref
      dates = []
      _ref = this.rawCopyToDates
      for (key in _ref) {
        value = _ref[key]
        dates.push(value)
      }
      dates.sort(function (a, b) {
        if (a.isBefore(b)) {
          return -1
        } else if (a.isAfter(b)) {
          return 1
        } else {
          return 0
        }
      })
      return dates
    },
    mustHaveIsComplete () {
      return this.selectedGroup && (this.eventType != null) && (this.eventType !== '-1' || this.newEventType !== '') && this.name && this.startTime && this.endTime
    },
    eventTypes () {
      var group
      if (!this.selectedGroup) {
        return false
      }
      group = this.selectedGroup
      if (group == null) {
        return false
      }
      this.$store.dispatch('groops/loadEventTypesForGroup', group)
      if (this.eventType == null && group.eventTypes && Object.keys(group.eventTypes).length > 0) {
        if (this.fromEvent) {
          this.eventType = _.findKey(group.eventTypes, o => o.text === this.fromEvent.type)
          if (_.isUndefined(this.eventType)) {
            this.eventType = '-1'
            this.newEventType = this.fromEvent.type
          }
        } else {
          this.eventType = Object.keys(group.eventTypes)[0]
        }
      }
      return group.eventTypes
    },
    nameHelp () {
      var endDuration, endHour, hourRegex, hours, hoursRegex, startHour
      hourRegex = '(2[0-3]|[01]?[0-9])((:|h|H)?([0-5][0-9])?)'
      hoursRegex = new RegExp(hourRegex + '(\\s|-|>)*(' + hourRegex + ')?(.*)$')
      startHour = null
      endHour = null
      hours = hoursRegex.exec(this.name)
      if (hours != null) {
        startHour = hours[1] + ':' + (hours[4] != null ? hours[4] : '00')
        if (hours[7] != null) {
          endHour = hours[7] + ':' + (hours[10] != null ? hours[10] : '00')
        }
        if (endHour == null) {
          endDuration = moment.duration(startHour).add(1, 'hour')
          endHour = endDuration.hours() + ':' + (endDuration.minutes() < 10 ? '0' + endDuration.minutes() : endDuration.minutes())
        }
        return {
          start: startHour,
          end: endHour,
          name: (this.name.substr(0, hours.index) + hours[11]).trim()
        }
      }
      return null
    },
    isEditing () {
      return (this.fromEvent != null) && (this.fromEvent.id != null)
    }
  },
  methods: {
    openModal () {
      this.open = true
      this.savingState = null
      $(this.$refs.modal).modal('show')
    },
    closeModal () {
      if (!this.open) {
        return
      }
      this.open = false
      $(this.$refs.modal).modal('hide')
      modalsBus.close(modalsBus.modals.CREATE_EVENT)
    },
    initDateRange () {
      // var dateRangeOptions
      // dateRangeOptions = {
      //   locale: {
      //     format: Vue.i18n.t('globals.dateTimeFormat'),
      //     separator: ' - ',
      //     applyLabel: 'Appliquer',
      //     cancelLabel: 'Annuler',
      //     fromLabel: 'De',
      //     toLabel: 'À',
      //     customRangeLabel: 'Personnalisé',
      //     daysOfWeek: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
      //     monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      //     firstDay: 1
      //   },
      //   parentEl: this.$refs.modal,
      //   'timePicker': true,
      //   'timePicker24Hour': true,
      //   'timePickerIncrement': 5,
      //   'startDate': this.startTime,
      //   'endDate': this.endTime,
      //   'opens': 'center'
      // }
      // $(this.$refs.inputDates).daterangepicker(dateRangeOptions, (start, end, label) => {
      //   if (start.isSame(end)) {
      //     end.add(DEFAULT_MINUTES_GAP_BETWEEN_DATES, 'minutes')
      //   }
      //   this.startTime = start
      //   this.endTime = end
      //   $(this.$refs.inputDates).trigger('change')
      // })
      let format = Vue.i18n.t('globals.dateTimeFormat')
      this.datePickerStart = this.startTime.format(format)
      this.datePickerEnd = this.endTime.format(format)
    },
    copyEvent () {
      var newEvent
      if (this.fromEvent == null) {
        return
      }
      newEvent = _.cloneDeep(this.fromEvent)
      newEvent.id = null
      newEvent.group = null
      this.fromEvent = newEvent
    },
    createEvent (event) {
      var call, copyDates, group, m, newType, type
      if (!this.mustHaveIsComplete) {
        this.hasClickedOnCreateBtn = true
        return
      }
      group = this.selectedGroup
      type = '-1'
      newType = this.newEventType
      event.doNotDesactiveOnClick = true // to let the accordion item open if necessary (the saving btn will be removed at next line)
      this.savingState = 'saving'
      if (this.eventType !== '-1') {
        type = group.eventTypes[this.eventType]
        if (type.standard) {
          type = type.key
        } else {
          newType = type.text
          type = type.key
        }
      }
      call = null
      if (this.isEditing) {
        call = this.$store.dispatch('events/putEvent', {
          id: this.fromEvent.id,
          name: this.name,
          startTime: this.startTime.unix(),
          endTime: this.endTime.unix(),
          type: type,
          newType: newType,
          maybe: this.maybe,
          description: this.description,
          address: this.address,
          url: this.url,
          sendMail: this.sendMail,
          publishOnGroupPage: this.publishOnGroupPage,
          blinded: this.blinded
        })
      } else {
        copyDates = []
        if (this.copyToOtherDates) {
          for (let i = 0; i < this.copyToDates.length; i++) {
            m = this.copyToDates[i]
            copyDates.push(m.format('YYYY/MM/DD'))
          }
        }
        call = this.$store.dispatch('events/postEvent', {
          gid: this.selectedGroup.id,
          name: this.name,
          startTime: this.startTime.unix(),
          endTime: this.endTime.unix(),
          type: type,
          newType: newType,
          maybe: this.maybe,
          description: this.description,
          address: this.address,
          url: this.url,
          sendMail: this.sendMail,
          publishOnGroupPage: this.publishOnGroupPage,
          copyToDates: copyDates,
          blinded: this.blinded
        })
      }
      let eventType = this.eventType
      let isEditing = this.isEditing
      let fromEvent = this.fromEvent
      return call.then((response) => {
        this.savingState = 'saved'
        let data = response.data
        let events = data.events || []
        if (data.event) {
          for (let k in data.event) {
            let v = data.event[k]
            fromEvent[k] = v
          }
          events.push(data.event)
        }

        if (eventType === '-1') {
          this.$store.dispatch('groops/reloadEventTypesForGroup', group)
        }
        this.eventsBus.$emit(this.eventsBus.NEW_EVENT, {events: events})
        setTimeout(() => {
          this.closeModal()
          if (isEditing) {
            modalsBus.open(modalsBus.modals.OPEN_SHARED_OBJECT, fromEvent)
          }
        }, 500)
      }).catch((data) => {
        this.savingState = 'error'
        setTimeout(function () {
          this.savingState = null
        }, 2000)
      })
    },
    cancel () {
      this.closeModal()
    },
    initValues () {
      this.rawCopyToDates = {}
      this.copyToOtherDates = false
      this.hasClickedOnSelectAGroup = false
      this.hasClickedOnCreateBtn = false
      if (this.fromEvent != null) {
        if (!this.fromEvent.group) {
          this.selectedGroup = null
        } else {
          this.selectedGroup = _.find(this.groopsWithOwn, (g) => g.id === this.fromEvent.group.id)
        }
        this.name = this.fromEvent.name
        this.description = this.fromEvent.description
        this.address = this.fromEvent.streetAndNum
        this.url = this.fromEvent.url
        this.startTime = moment.unix(this.fromEvent.startTime)
        this.endTime = moment.unix(this.fromEvent.endTime)
        // this.eventType = this.fromEvent.type
        // this.newType = this.fromEvent.newType
        this.maybe = this.fromEvent.hasMaybe
        this.publishOnGroupPage = this.fromEvent.public
        this.blinded = this.fromEvent.blinded
      } else {
        this.selectedGroup = this.firstSelectedGroop || null
        this.name = ''
        this.description = ''
        this.address = ''
        this.url = ''
        this.startTime = moment().startOf('hour').add(1, 'h')
        this.endTime = moment().startOf('hour').add(1, 'h').add(DEFAULT_MINUTES_GAP_BETWEEN_DATES, 'm')
        this.eventType = null
        this.newType = null
        this.maybe = false
        this.publishOnGroupPage = true
        this.blinded = false
      }
      this.sendMail = true
      this.savingState = null
      this.updateDates()
      this.$nextTick(() => {
        autosize($('textarea, input', this.$refs.modal))
      })
    },
    updateDates () {
      let format = Vue.i18n.t('globals.dateTimeFormat')
      this.datePickerStart = this.startTime.format(format)
      this.datePickerEnd = this.endTime.format(format)
    },
    useNameHelpIfCtrlEnter (event) {
      if (event.ctrlKey) {
        return this.useNameHelp()
      }
    },
    useNameHelp () {
      var end, help, start
      help = this.nameHelp
      this.name = help.name
      start = moment.duration(help.start)
      end = moment.duration(help.end)
      this.startTime.set({
        hours: start.hours(),
        minutes: start.minutes()
      })
      this.endTime.set({
        hours: end.hours(),
        minutes: end.minutes()
      })
      while (this.endTime.isBefore(this.startTime)) {
        this.endTime.add(1, 'day')
      }
      this.startTime = this.startTime.clone()
      this.endTime = this.endTime.clone()
    },
    toggleFileMode () {
      return modalsBus.open(modalsBus.modals.IMPORT_ICS)
    },
    clickOnSelectAGroup () {
      if (this.isEditing) {
        this.hasClickedOnSelectAGroup = true
      }
    }
  },
  filters: {
    unixtimeTo
  },
  watch: {
    mustHaveIsComplete () {
      this.$nextTick(() => {
        autosize($('textarea, input', this.$refs.modal))
      })
    },
    selectedGroops (newValue, oldValue) {
      if (_.difference(newValue, oldValue).length === 0 && _.difference(oldValue, newValue).length === 0) {
        return
      }
      this.selectedGroup = this.firstSelectedGroop || null
    },
    fromEvent () {
      this.initValues()
    },
    startTime (newValue) {
      this.updateDates()
    },
    endTime (newValue) {
      this.updateDates()
    },
    // open (newValue) {
    //   if (!newValue) {
    //     this.fromEvent = null
    //     this.initValues()
    //     this.closeModal()
    //   } else {

    //   }
    // },
    eventType (newValue) {
      if (newValue === '-1') {
        this.$nextTick(() => {
          $(this.$refs.newEventTypeInput).focus()
        })
      }
    },
    datePickerStart () {
      let format = Vue.i18n.t('globals.dateTimeFormat')
      let diff = this.endTime.diff(this.startTime)
      this.startTime = moment(this.datePickerStart, format)
      this.endTime = this.startTime.clone().add(diff, 'milliseconds')
      this.datePickerEnd = this.endTime.format(format)
    },
    datePickerEnd () {
      let format = Vue.i18n.t('globals.dateTimeFormat')
      this.endTime = moment(this.datePickerEnd, format)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Events-CreateEventModal.vue?37a6c6a8